import {
  ActionCsv,
  ExecuteCommandArgsCsv,
  LinkToSynopticArgsCsv,
  ShowTooltipArgsCsv,
  SynopticConfigurationComponentCsv,
  SynopticElementEventPreview,
  SynopticElementStatePreview,
  TooltipRowCsv
} from '../../../../model/synoptics/synoptic-configuration-csv-types';
import {
  SynopticConfigurationComponent,
  SynopticElementAction,
  SynopticElementEvent,
  SynopticElementState
} from '../../../../model/synoptics/synoptic-configuration-types';
import {
  ExecuteCommandArgs,
  LinkToSynopticArgs,
  ShowPopupArgs,
  ShowPopupArgsCsv,
  ShowTooltipArgs,
  TooltipRow
} from '../../../../model/synoptics/synoptic-arg-types';

export class SynopticConfigAdapter {
  public static transformSynopticConfigurationComponentCsvToSynopticConfigurationComponent(configurations: SynopticConfigurationComponentCsv[]): SynopticConfigurationComponent[] {
    return configurations.map(config => ({
      file: config.file,
      name: config.name,
      states: SynopticConfigAdapter.transformStateCsvToState(config.states),
      events: SynopticConfigAdapter.transformEventCsvToState(config.events),
      statics: config.statics,
    }));
  }

  public static transformStateCsvToState(objects: SynopticElementStatePreview[]): SynopticElementState[] {
    return objects.map(obj => ({
      id: obj.id,
      sensorIdentifier: {
        entityType: obj.sensorIdentifier.entityType,
        entityUuid: obj.sensorIdentifier.entityUuid,
        sensorUuid: obj.sensorIdentifier.sensorUuid,
      },
      modifier: obj.modifier,
    }));
  }

  public static transformEventCsvToState(objects: SynopticElementEventPreview[]): SynopticElementEvent[] {
    return objects.map(obj => ({
      id: obj.id,
      trigger: obj.trigger,
      action: this.transformElementActionCsvToElementAction(obj.action),
    }));
  }

  public static transformElementActionCsvToElementAction(object: ActionCsv): SynopticElementAction {
    let args;
    switch (object.type) {
      case 'executeCommand': {
        const executeCommand: ExecuteCommandArgsCsv = object.args as ExecuteCommandArgsCsv;
        args = {
          deviceUuid: executeCommand.deviceUuid,
          schema: executeCommand.schema,
          command: executeCommand.command,
          askParamsToUser: executeCommand.askParamsToUser,
          params: executeCommand?.params
        } as ExecuteCommandArgs;
        break;
      }
      case 'showTooltip': {
        const showTooltip: ShowTooltipArgsCsv = object.args as ShowTooltipArgsCsv;
        args = {
          title: showTooltip.title,
          rows: showTooltip.rows.map((row: TooltipRowCsv) => ({
            label: row.label,
            value: {
              entityType: row.value.entityType,
              entityUuid: row.value.entityUuid,
              sensorUuid: row.value.sensorUuid,
            }
          } as TooltipRow)),
          showDates: showTooltip.showDates
        } as ShowTooltipArgs;
        break;
      }

      case 'showPopup': {
        const showPopup: ShowPopupArgsCsv = object.args as ShowPopupArgsCsv;
        args = {
          component: showPopup.component
        } as ShowPopupArgs;
        break;
      }
      case 'linkToSynoptic': {
        const linkToSynoptic: LinkToSynopticArgsCsv = object.args as LinkToSynopticArgsCsv;
        args = {
          synopticUuid: linkToSynoptic.synopticUuid
        } as LinkToSynopticArgs;
        break;
      }
      default: {
        args = {};
        break;
      }
    }

    return {
      type: object.type as 'executeCommand' | 'showPopup' | 'closePopup' | 'showTooltip' | 'linkToSynoptic',
      args: args
    };
  }
}
